import { EnvironmentTypes } from "@/app.environments.js";
import ProcessEnvironment from "@/constants/ProcessEnvironment";

const { DeploymentEnvironment: CurrentEnvironmentType } = ProcessEnvironment;

const isProductionEnvironment = () =>
  CurrentEnvironmentType === EnvironmentTypes.Production;
const isLocalEnvironment = () =>
  CurrentEnvironmentType === EnvironmentTypes.Local || __DEV__;
const isDevelopmentEnvironment = () =>
  CurrentEnvironmentType === EnvironmentTypes.Development ||
  CurrentEnvironmentType === EnvironmentTypes.Labs;
const isQAEnvironment = () => CurrentEnvironmentType === EnvironmentTypes.QA;
const isStagingEnvironment = () =>
  CurrentEnvironmentType === EnvironmentTypes.Staging;

const shouldUseDevToolsEnhancer = isLocalEnvironment;

export {
  isDevelopmentEnvironment,
  isLocalEnvironment,
  isProductionEnvironment,
  isQAEnvironment,
  isStagingEnvironment,
  shouldUseDevToolsEnhancer,
};
